import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {MatchVideo} from '@shared/models/match-video';

@Component({
  selector: 'youtube-video',
  templateUrl: './youtube-video.component.html',
  styleUrls: ['./youtube-video.component.scss']
})
export class YoutubeVideoComponent implements OnInit {
  @Input() videoURL: string;
  @Input() simpleStyling: boolean = false;

  safeURL: SafeResourceUrl;

  constructor(private _sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.videoURL = MatchVideo.makeEmbedURL(this.videoURL);
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoURL);
  }
}
